import React, { FC } from "react";

import {
  useSearchManagersInsightPostObjectives,
  useApisManagersBelongingEmployeesInsightPostObjectivesIndex,
} from "~/hooks";

import { TabItemLinks } from "~/components/atoms";
import {
  EmployeeLayout,
  EmployeeLayoutMainContent,
} from "~/components/layouts";
import { ManagersInsightPostObjectivesIndexTemplate } from "~/components/templates";

export const ManagersBelongingEmployeesInsightPostObjectivesIndex: FC = () => {
  const {
    insightPostObjectives,
    keyword,
    isLoading,
    hasNextPage,
    startDate,
    endDate,
    selectableDropdownPublicStatusIds,
    selectedDropdownPublicStatusId,
    selectableDropdownDivisions,
    selectedDropdownDivisions,
    selectableDropdownSections,
    selectedDropdownSections,
    onDivisionChange,
    onSectionChange,
    findAndRemove,
    onChangeDropdownPublicStatusId,
    fetchNextPage,
    onChangeDateRange,
    onChangeKeyword,
    onConditionReset,
    onSearchSubmit,
  } = useSearchManagersInsightPostObjectives({
    useApisInsightPostObjectives:
      useApisManagersBelongingEmployeesInsightPostObjectivesIndex,
  });

  const breadCrumbItems = [
    { label: "メモログ目標", href: "/managers/insight_post_objectives" },
    { label: "一覧", href: "/managers/insight_post_objectives" },
  ];

  return (
    <EmployeeLayout withRightSidebar={false} breadCrumbItems={breadCrumbItems}>
      <EmployeeLayoutMainContent withRightSidebar={false}>
        <TabItemLinks
          items={[
            {
              name: "チームに蓄積",
              href: "/managers/insight_post_objectives",
              isActive: false,
            },
            {
              name: "過去所属先での対応含む",
              href: "/managers/belonging_employees/insight_post_objectives",
              isActive: true,
            },
          ]}
        />
        <ManagersInsightPostObjectivesIndexTemplate
          className="mt-8"
          insightPostObjectives={insightPostObjectives}
          keyword={keyword}
          isLoading={isLoading}
          hasNextPage={hasNextPage}
          startDate={startDate}
          endDate={endDate}
          selectableDropdownPublicStatusIds={selectableDropdownPublicStatusIds}
          selectedDropdownPublicStatusId={selectedDropdownPublicStatusId}
          selectableDropdownDivisions={selectableDropdownDivisions}
          selectedDropdownDivisions={selectedDropdownDivisions}
          selectableDropdownSections={selectableDropdownSections}
          selectedDropdownSections={selectedDropdownSections}
          onDivisionChange={onDivisionChange}
          onSectionChange={onSectionChange}
          findAndRemove={findAndRemove}
          onChangeDropdownPublicStatusId={onChangeDropdownPublicStatusId}
          fetchNextPage={fetchNextPage}
          onChangeDateRange={onChangeDateRange}
          onChangeKeyword={onChangeKeyword}
          onConditionReset={onConditionReset}
          onSearchSubmit={onSearchSubmit}
        />
      </EmployeeLayoutMainContent>
    </EmployeeLayout>
  );
};
